import { render, staticRenderFns } from "./PricingHeader.vue?vue&type=template&id=5e07115e&scoped=true&"
import script from "./PricingHeader.vue?vue&type=script&lang=js&"
export * from "./PricingHeader.vue?vue&type=script&lang=js&"
import style0 from "./PricingHeader.vue?vue&type=style&index=0&id=5e07115e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e07115e",
  null
  
)

export default component.exports